import ProductType from '../enums/ProductType';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logWebProModalPurchaseButtonTappedParams = {
  product_type?: ProductType;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * When a user a user taps the CTA in the the pro upsell modal on web.
 * @param params - Attributes to log with the amplitude event
 * @param params.copy_text - Deprecated in Apr 2025 as the values are just reflective of trial or not status and duplicative to purchase screen type plan.
 * @param params.product_type - The subscription type selected from the upsell menu (e.g. free, plus, peak)
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo).
 * @param params.trigger - The trigger that caused the web pro modal to display.
 */
const logWebProModalPurchaseButtonTapped = (
  { product_type, purchase_screen_type_plan, trigger }: logWebProModalPurchaseButtonTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'web pro modal purchase button tapped',
    { 'product type': product_type, 'purchase screen type plan': purchase_screen_type_plan, trigger },
    callback
  );
};

export default logWebProModalPurchaseButtonTapped;
